<template>

    <router-view></router-view>

</template>
<script>
export default {
	beforeRouteUpdate(to, from, next) {
		if(to.name == 'Users'){
			next({ name: 'GerenciarUsers' })
		}else{
			next()
		}
	},
	created() {
		if(this.$route.name == 'Users'){
			this.$router.push({ name: 'GerenciarUsers' })
		}
	}
}
</script>